module.exports = __webpack_public_path__ + "img/1.fcb75f3b.png";